export default {
  placeholder: 'Buscar restaurante...',
};
